import LinkButton from '@carvana/ds-link-button';
import useModal from '@carvana/ds-modal';

import { Wrapper } from './styles';
import WhereIsMyVinContent from './WhereIsMyVinContent';

const WhereIsMyVin = () => {
  const portalRoot = document.getElementById('modal-root') as Element;
  const { Modal, openModal, closeModal } = useModal({ rootNode: portalRoot });

  return (
    <Wrapper>
      <LinkButton variant="default" size="sm" underline={false} onClick={openModal}>
        Where is my VIN?
      </LinkButton>
      <Modal divLine={false} desktopWidth="580px" mobileStyle="inset">
        <WhereIsMyVinContent closeModal={closeModal} />
      </Modal>
    </Wrapper>
  );
};

export default WhereIsMyVin;
